<template>
    <div>
        <!-- <el-card shadow="never">
            <div slot="header" class="clearfix">
                <span>操作管理</span>
            </div> -->
            <el-row>
                <el-col :span="18">
                    <el-button type="primary" @click="add">添加操作</el-button>
                </el-col>
            </el-row>
            <div>
                <el-table :data="tables" row-key="id"
                    :tree-props="{children: 'buttonList', hasChildren: 'hasChildren'}">
                    <el-table-column label="ID" prop="id">
                    </el-table-column>
                    <el-table-column label="操作名称" prop="alias">
                    </el-table-column>
                    <el-table-column label="字段名称" prop="name"></el-table-column>
                    <el-table-column align="center" label="操作" width="280px">
                        <template slot-scope="scope">
                            <el-button
                                size="mini"
                                type="primary"
                                @click="addChild(scope.row)"
                                style="margin-bottom:4px;"
                            >添加子操作</el-button>
                            <el-button
                                size="mini"
                                type="primary"
                                @click="edit(scope.row)"
                                style="margin-bottom:4px;"
                            >编辑</el-button>
                            <el-button
                                size="mini"
                                type="danger"
                                @click="delConfirm(scope.row)"
                            >删除</el-button>

                            <el-button v-if="scope.$index != 0"
                                size="mini"
                                type="primary"
                                @click="changeRank(scope.row, 'up')"
                            >上移</el-button>
                            <el-button v-if="scope.$index != tables.length - 1"
                                size="mini"
                                type="primary"
                                @click="changeRank(scope.row, 'down')"
                            >下移</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        <!-- </el-card> -->

        <operation-add v-if="showAddBox"
            :visible="showAddBox"
            :formData="operation"
            :listdata="tables"
            :menuId="currentMenu.id"
            @operationAddCallback="operationAddCallback"
            @findByAppId="findByAppId"/>
    </div>
</template>
<script>
import { Loading } from "element-ui"
import OperationAdd from './OperationAdd'
export default {
    components: { OperationAdd },
    props: {
        // 在哪个菜单上加操作
        // menuId: {
        //     type: [Number, String]
        // },
        // 当前操作的是那个菜单
        currentMenu: {
            type: Object
        }
    },
    data: vm=>({
        tables: [],
        search: null,
        showAddBox: false,
        operation: null,
    }),
    created(){
        // this.getList()
        if(this.currentMenu && this.currentMenu.id){
            // this.findById(this.currentMenu.id)
            this.findByAppId(this.currentMenu.id)
        }
    },
    methods: {
        // 移动：上移up, 下移down
        changeRank(row, type){

            let idStr = '/'
            idStr += type + '/'+ row.id

            this.$axios.get(this.baseUrl3 + 'button/changeRank' + idStr)
            .then(({data:{data, msg, code}})=>{
                if(code == 20000){
                    // this.getList()
                    this.findByAppId()
                    this.$message.success('操作成功')
                }else{
                    this.$message.error('操作失败：' + msg)
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        getList(){
            let loading = Loading.service({
                fullscreen: true,
                text: "数据加载中..."
            });
            this.$axios.get(this.baseUrl3 + 'function/findAll')
            .then(({data:{data, msg, code}})=>{
                if(code == 20000){
                    this.tables = data
                }else{
                    this.$message.error('操作失败：' + msg)
                }
                loading.close()
            })
            .catch(err => {
                console.log(err)
                loading.close()
            })
        },
        add(){
            this.showAddBox = true
        },
        addChild(row){
            this.operation = {
                parentId: row.id,
                // listdata: this.tables
            }
            this.showAddBox = true
        },
        edit(row){
            this.operation = row
            // this.operation.listdata = this.tables
            this.showAddBox = true
        },
        del(row){
            this.$axios
                .get(this.baseUrl3 + "button/del/" + row.id)
                .then(({ data: { msg, data, code } }) => {
                    if (code == 20000) {
                        this.$message.success('操作成功')
                        // this.getList()
                        this.findByAppId()
                    } else {
                        this.$message({ showClose: true, message: msg, type: "error" });
                        console.log(msg);
                    }
                })
                .catch(error => {
                    this.$message({
                        showClose: true,
                        message: "系统异常",
                        type: "error"
                    });
                    console.log(error);
                });
        },
        delConfirm(row){
            this.$confirm('您确认要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.del(row)
            }).catch(() => {

            });
        },
        operationAddCallback(val){
            this.operation = null
            this.showAddBox= false
            if(val != false){
                // this.getList()
                this.findByAppId()
            }
        },

        findById(){
            let loading = Loading.service({
                fullscreen: true,
                text: "数据加载中..."
            });
            let url = this.baseUrl3 + "app/findById/" + this.currentMenu.id
            this.$axios
                .get(url)
                .then(({ data: { msg, data, code } }) => {
                    if (code == 20000) {
                        this.tables = data.functionList

                    } else {
                        this.$message({ showClose: true, message: msg, type: "error" });
                        console.log(msg);
                    }
                    loading.close();
                })
                .catch(error => {
                    loading.close();
                    this.$message({
                        showClose: true,
                        message: "系统异常",
                        type: "error"
                    });
                    console.log(error);
                });
        },
        findByAppId(){
            let loading = Loading.service({
                fullscreen: true,
                text: "数据加载中..."
            });
            let url = this.baseUrl3 + "button/findAll/" + this.currentMenu.id

            this.$axios
                .get(url)
                .then(({ data: { msg, data, code } }) => {
                    if (code == 20000) {
                        this.tables = data

                    } else {
                        this.$message({ showClose: true, message: msg, type: "error" });
                        console.log(msg);
                    }
                    loading.close();
                })
                .catch(error => {
                    loading.close();
                    this.$message({
                        showClose: true,
                        message: "系统异常",
                        type: "error"
                    });
                    console.log(error);
                });
        },

    }
}
</script>
